<div class="to-buy-container">
    <div class="to-buy" (click)="clickObtain()">
        <img src="/assets/img/ToBuy.svg" alt="file to buy">
    </div>
</div>